import { AddressGroup, FwVersionContentAndMetadata } from '../dtos/version.dto';
import axiosService from './axios-service';

class AddressGroupService {
    public createAddressGroup = async (customerId: number, sid: number, versionId: string, addressGroup: AddressGroup): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.post(`/api/firewall/customer/${customerId}/service/${sid}/addressGroup`, {
            ...addressGroup,
            externalId: versionId
        });
        return result?.data;
    };

    public updateAddressGroup = async (customerId: number, sid: number, versionId: string,
        updatedAddressGroup: AddressGroup, originalDisplayName: string): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.put(`/api/firewall/customer/${customerId}/service/${sid}/addressGroup`, {
            ...updatedAddressGroup,
            externalId: versionId,
            originalDisplayName,
        });
        return result?.data;
    };

    public deleteAddressGroup = async (customerId: number, sid: number, versionId: string, groupDisplayName: string): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.delete(`/api/firewall/customer/${customerId}/service/${sid}/addressGroup`, {
            externalId: versionId,
            objectDisplayName: groupDisplayName,
        });
        return result?.data;
    };
}

const addressGroupService = new AddressGroupService();
export default addressGroupService;